<script>
    import { createEventDispatcher } from 'svelte';

    export let badges = [];
    export let view = 'grid';

    const dispatch = createEventDispatcher();

    // List view has the room to say which axis each badge is on. Cards view does not: the three
    // badges split the card into equal tracks, so anything longer than about ten characters
    // ellipsises. Badges whose full label does not fit carry a terse `short` for that view; the
    // full wording stays in the title attribute and in List view either way.
    //
    // Takes currentView as an argument rather than closing over `view`: Svelte only tracks the
    // identifiers written directly in a template expression, so a call written as
    // {labelFor(badge)} would not re-run when `view` changed on its own, leaving every label
    // frozen at its first render.
    function labelFor(badge, currentView) {
        return currentView === 'list' ? `${badge.shortLabel}: ${badge.label}` : badge.short || badge.label;
    }
</script>

{#if badges.length > 0}
    <span class="guide-card-badges">
        {#each badges as badge}
            {#if badge.facet}
                <button
                    type="button"
                    class="guide-badge-chip guide-badge-chip--{badge.slug}"
                    title="{badge.meaning}: {badge.label}"
                    on:click={() => dispatch('selectFacet', badge.facet)}>
                    <i class={badge.icon} aria-hidden="true"></i>
                    <span class="guide-badge-chip-name">{labelFor(badge, view)}</span>
                    <span class="sr-only">{badge.meaning}</span>
                </button>
            {:else}
                <span
                    class="guide-badge-chip guide-badge-chip--{badge.slug}"
                    title="{badge.meaning}: {badge.label}">
                    <i class={badge.icon} aria-hidden="true"></i>
                    <span class="guide-badge-chip-name">{labelFor(badge, view)}</span>
                    <span class="sr-only">{badge.meaning}</span>
                </span>
            {/if}
        {/each}
    </span>
{/if}
